import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimDescription',
  standalone: false,
})
export class TrimDescriptionPipe implements PipeTransform {
  transform(text: string, length: number): string {
    if (text.length <= length) {
      return text;
    }
    return text.substring(0, length).concat('…');
  }
}
